import { createState } from '~/src/hooks/useEoState'

export const PRODUCT_COMMENT_STATE = createState({
  key: 'productCommentState',
  default: ''
})
